import {SubsidyType} from './models/subsidy-type.type';
import {LOGIES_STEPS} from './modules/logies/models/logies-steps.data';
import {IVV_STEPS} from './modules/ivv/models/ivv-steps.data';

export interface SubsidyConfig {
	type: SubsidyType;
	internalType?: string;
	allow: 'user' | 'organization' | 'all';
	context: string;
	create: 'instant' | 'new';
	disableStep0?: boolean;
	email?: string;
	hasHtmlDescriptions?: boolean;
	icon: string;
	name: string;
	paymentRequest?: {
		document?: string;
		warningMessage?: string;
	};
	report?: true | string;
	steps: string[];
	text?: string; // subsidie in het kader van ...
}

const SUBSIDIES_CONFIG: SubsidyConfig[] = [
	{
		type: 'logies',
		allow: 'all',
		context: 'SUBSIDY_LOGIES',
		create: 'new',
		email: 'logiessubsidie@toerismevlaanderen.be',
		hasHtmlDescriptions: false,
		icon: 'icon-logies.png',
		name: 'Logies',
		paymentRequest: {},
		steps: LOGIES_STEPS,
	},
	{
		type: 'ivv',
		allow: 'organization',
		context: 'SUBSIDY_IVV',
		create: 'instant',
		email: 'oproepivv@toerismevlaanderen.be',
		hasHtmlDescriptions: true,
		icon: 'icon-ivv.png',
		name: 'Iedereen Verdient Vakantie',
		// report, paymentRequest -> custom
		steps: IVV_STEPS,
	},
	{
		type: 'ivv_sto',
		internalType: 'sto',
		allow: 'organization',
		context: 'SUBSIDY_STO',
		create: 'instant', // custom
		email: 'sto@iedereenverdientvakantie.be',
		hasHtmlDescriptions: true,
		icon: 'icon-ivv.png',
		name: 'Sociaal-toeristische organisatie',
		steps: [
			'Handleiding',
			'Organisatiegegevens',
			'Beleidsplan en begroting',
			'Berekening subsidie',
			'Ontvangen subsidies',
			'Verklaring op eer'
		],
		text: 'subsidie als sociaal-toeristische organisatie',
	},

	{
		type: 'jv',
		allow: 'all',
		context: 'SUBSIDY_JV',
		create: 'instant',
		hasHtmlDescriptions: true,
		icon: 'icon-logies.png',
		name: 'Jeugdverblijven',
		paymentRequest: {
			document: 'uitgavenstaat-infrastructuursubsidie-jeugdverblijven.xlsx',
			warningMessage: 'LET OP<ul><li>Bij een toegekende subsidie van minder dan 50.000 euro, kan je maar één betalingsaanvraag indienen. Alle verantwoordingsstukken worden in dat geval in 1 keer tegelijk ingediend op het einde van het totaalproject (na het uitvoeren van alle werken en aankopen).</li><li>Bij een toegekende subsidie van meer dan 50.000 euro en minder dan 150 000 euro, kunnen er uitzonderlijk maximaal 2 betalingsaanvragen worden ingediend.</li><li>Bij een toegekende subsidie van meer dan 150 000 euro kunnen er maximaal 4 betalingsaanvragen worden ingediend. Je bepaalt in dat geval zelf de grootte van het bedrag waarvoor je een eerste betalingsaanvraag indient.</li></ul>',
		},
		report: 'Tussentijdse rapportage',
		steps: [
			'Handleiding',
			'Gegevens jeugdverblijf',
			'Project',
			'Projectplanning',
			'Financieel plan',
			'Verklaringen op eer'
		]
	},
	{
		type: 'nwb',
		allow: 'organization',
		context: 'SUBSIDY_NWB',
		create: 'instant',
		hasHtmlDescriptions: true,
		icon: 'icon-nature.png',
		name: 'Natuur- & waterbeleving',
		paymentRequest: {
			document: 'uitgavenstaat-natuur.xlsx',
		},
		report: 'Tussentijdse rapportage',
		steps: [
			'Handleiding',
			'Organisatiegegevens',
			'Project',
			'Locatie',
			'Doelgroepen',
			'Projectplanning',
			'Financieel plan',
			'De-minimis',
			'Verklaringen op eer',
		]
	},
	{
		type: 'wo1',
		allow: 'organization',
		context: 'SUBSIDY_WO1',
		create: 'instant',
		hasHtmlDescriptions: true,
		icon: 'icon-nature.png',
		name: 'WO1 infrastructuur',
		report: 'Tussentijdse rapportage',
		paymentRequest: {
			document: 'uitgavenstaat-wo1.xlsx',
		},
		steps: [
			'Handleiding',
			'Organisatiegegevens',
			'Project',
			'Projectplanning',
			'Financieel plan',
			'Verklaringen op eer',
		]
	},
];

export function getSubsidyConfig(type: SubsidyType | string | undefined): SubsidyConfig | null {
	return SUBSIDIES_CONFIG.find(c => c.type === type || c.internalType === type) || null;
}
